import { useQuery } from '@hooks/reactQuery';

import { getBoroughs } from '@api/map';

import { DAY_IN_MS } from '@constants/common';
import { BOROUGHS } from '@constants/queryKeys';

export const useQueryBoroughs = () => {
	const {
		data: boroughs,
		isLoading: isLoadingBoroughs,
		isFetching: isFetchingBoroughs,
	} = useQuery({
		queryKey: [BOROUGHS],
		queryFn: getBoroughs,
		refetchOnWindowFocus: false,
		staleTime: DAY_IN_MS,
	});

	return {
		boroughs,
		isLoadingBoroughs: isLoadingBoroughs && isFetchingBoroughs,
	};
};
